import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from 'libs/axios/axios';

const editSafetyMeasure = async (values: { targetId: number; inputValue: string }) => {
  const { targetId, inputValue } = values;

  const { data } = await axiosClient.patch(`/safety-measure/${targetId}`, {
    name: inputValue,
  });

  return data;
};

const useEditSafetyMeasureQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(['safetyMeasure', 'edit'], editSafetyMeasure, {
    onSuccess: () => {
      queryClient.invalidateQueries(['safetyMeasure', 'list']);
    },
    onError: (error) => {
      alert('수정 실패. 다시 한 번 시도해주세요');
      console.error('edit safetyMeasure error', error);
    },
  });
};

export default useEditSafetyMeasureQuery;
